/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProxyResponse } from './ProxyResponse';
import {
    ProxyResponseFromJSON,
    ProxyResponseFromJSONTyped,
    ProxyResponseToJSON,
    ProxyResponseToJSONTyped,
} from './ProxyResponse';
import type { RegionResponse } from './RegionResponse';
import {
    RegionResponseFromJSON,
    RegionResponseFromJSONTyped,
    RegionResponseToJSON,
    RegionResponseToJSONTyped,
} from './RegionResponse';
import type { AppParametersResponse } from './AppParametersResponse';
import {
    AppParametersResponseFromJSON,
    AppParametersResponseFromJSONTyped,
    AppParametersResponseToJSON,
    AppParametersResponseToJSONTyped,
} from './AppParametersResponse';
import type { ClassifierResponse } from './ClassifierResponse';
import {
    ClassifierResponseFromJSON,
    ClassifierResponseFromJSONTyped,
    ClassifierResponseToJSON,
    ClassifierResponseToJSONTyped,
} from './ClassifierResponse';
import type { QueueTask } from './QueueTask';
import {
    QueueTaskFromJSON,
    QueueTaskFromJSONTyped,
    QueueTaskToJSON,
    QueueTaskToJSONTyped,
} from './QueueTask';
import type { DeviceInfoResponse } from './DeviceInfoResponse';
import {
    DeviceInfoResponseFromJSON,
    DeviceInfoResponseFromJSONTyped,
    DeviceInfoResponseToJSON,
    DeviceInfoResponseToJSONTyped,
} from './DeviceInfoResponse';

/**
 * Schema for RabbitMQ bot task messages.
 * 
 * The backend serializes this to JSON when publishing to the queue.
 * The worker (spring-bots) deserializes it to reconstruct bot process args.
 * @export
 * @interface BotTaskMessage
 */
export interface BotTaskMessage {
    /**
     * 
     * @type {string}
     * @memberof BotTaskMessage
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BotTaskMessage
     */
    labels?: string;
    /**
     * 
     * @type {number}
     * @memberof BotTaskMessage
     */
    groupId: number;
    /**
     * 
     * @type {QueueTask}
     * @memberof BotTaskMessage
     */
    task?: QueueTask | null;
    /**
     * 
     * @type {RegionResponse}
     * @memberof BotTaskMessage
     */
    region?: RegionResponse | null;
    /**
     * 
     * @type {DeviceInfoResponse}
     * @memberof BotTaskMessage
     */
    deviceInfo?: DeviceInfoResponse | null;
    /**
     * 
     * @type {ProxyResponse}
     * @memberof BotTaskMessage
     */
    proxy?: ProxyResponse | null;
    /**
     * 
     * @type {ClassifierResponse}
     * @memberof BotTaskMessage
     */
    classifier?: ClassifierResponse | null;
    /**
     * 
     * @type {AppParametersResponse}
     * @memberof BotTaskMessage
     */
    appParameters?: AppParametersResponse | null;
}

/**
 * Check if a given object implements the BotTaskMessage interface.
 */
export function instanceOfBotTaskMessage(value: object): value is BotTaskMessage {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    return true;
}

export function BotTaskMessageFromJSON(json: any): BotTaskMessage {
    return BotTaskMessageFromJSONTyped(json, false);
}

export function BotTaskMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BotTaskMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'labels': json['labels'] == null ? undefined : json['labels'],
        'groupId': json['group_id'],
        'task': json['task'] == null ? undefined : QueueTaskFromJSON(json['task']),
        'region': json['region'] == null ? undefined : RegionResponseFromJSON(json['region']),
        'deviceInfo': json['device_info'] == null ? undefined : DeviceInfoResponseFromJSON(json['device_info']),
        'proxy': json['proxy'] == null ? undefined : ProxyResponseFromJSON(json['proxy']),
        'classifier': json['classifier'] == null ? undefined : ClassifierResponseFromJSON(json['classifier']),
        'appParameters': json['app_parameters'] == null ? undefined : AppParametersResponseFromJSON(json['app_parameters']),
    };
}

export function BotTaskMessageToJSON(json: any): BotTaskMessage {
    return BotTaskMessageToJSONTyped(json, false);
}

export function BotTaskMessageToJSONTyped(value?: BotTaskMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'labels': value['labels'],
        'group_id': value['groupId'],
        'task': QueueTaskToJSON(value['task']),
        'region': RegionResponseToJSON(value['region']),
        'device_info': DeviceInfoResponseToJSON(value['deviceInfo']),
        'proxy': ProxyResponseToJSON(value['proxy']),
        'classifier': ClassifierResponseToJSON(value['classifier']),
        'app_parameters': AppParametersResponseToJSON(value['appParameters']),
    };
}

